module.exports = "/assets/hexsvg-db68f1ccf72f268468f6fa5bfb4615dd.svg";